<div style="flex-grow: 1; max-height: 450px; height: calc(100% - 50px)" #scrollResult>
	@if (summary) {
	<lex-prompt-response [responseText]="summary" [isLoading]="isLoading"></lex-prompt-response>
	}
	@if (isLoading) {
	<div style="display: flex; justify-content: center; height: 15px; width: 100%; padding: 20px 0;">
		<div class="dot-pulse"></div>
	</div>
	}
</div>